define('views/modules/questionnaire/questions/edit/question-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/questionnaire/options/options',
    'models/questionnaire/option',
    // views
    'views/parts/form/textarea',
    'views/parts/form/select',
    'views/parts/form/choices',
    'views/modules/questionnaire/questions/list/options/options-list',
    'views/modules/questionnaire/questions/list/options/option-list-item',
    // templates
    'text!templates/modules/questionnaire/questions/edit/question-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    COptions,
    MOption,
    // views
    VTextarea,
    VSelect,
    VChoices,
    VOptionsList,
    VOptionListItem,
    // templates
    TQuestionEditForm
) {

    var VQuestionEditForm = Backbone.View.extend({
        template: TQuestionEditForm,

        regions: {
            root: '.edit-question-infos',
            name: '.name-input',
            type: '.type-input',
            options: '.options-list',
            submit: '.submit-button',
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                view = this.view = {
                    name: new VTextarea({
                        label: 'questionnaire:Question',
                        attribute: 'name',
                        labelposition: 'outer',
                        autosize: true,
                        rows: 2,
                        model: model
                    }),
                    type: new VSelect({
                        label: 'questionnaire:Type',
                        labelposition: "top",
                        option: { label: 'name', value: 'value' },
                        attribute: 'type',
                        model: model,
                        collection: model.getTypes()
                    }),
                    options: new VOptionsList({
                        collection: this.collection,
                        item: VOptionListItem,
                        model: model,
                    }),
                };

            this.listenTo(model, {
                "change:type": this.onTypeChange,
                "model:reset": this.onModelReset,
            });
        },
        render: function() {

            // append the form
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.name, zone.$name)
                .assign(view.type, zone.$type)
                .assign(view.options, zone.$options);

            return this;
        },

        getOptions: function() {
            return this.collection.pluck('text');
        },

        ////////////
        // events //
        ////////////

        onTypeChange: function(model, value) {
            var isOptionsEnabled = _.contains(model.getTypeWithOptions(), value),
                optionsCollection = this.collection;

            if (isOptionsEnabled && !optionsCollection.length) {
                optionsCollection.add(new MOption(), { silent: !Boolean(this.zone) });
            }

            this.view.options.toggle(isOptionsEnabled);
        },

        onModelReset: function(model) {
            this.collection.reset(model.getOptions().models);
        },

    });

    return VQuestionEditForm;
});

